import { render, staticRenderFns } from "./nominationFormView.vue?vue&type=template&id=70f394a8&"
import script from "./nominationFormView.vue?vue&type=script&lang=js&"
export * from "./nominationFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports